export default __webpack_public_path__ + "assets/clock.48435786392009fb06b71dbc2d4bd4b8.svg";